var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","color":"grey lighten-1"}},[_c('v-spacer'),_c('span',{staticClass:"overline"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" SECRETARÍA GENERAL - Sesiones CGU V."+_vm._s(_vm.systemVersion))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }